import React from "react";

const Error = () => {
  return (
    <div className="flex h-screen justify-center items-center text-3xl text-pink-600">
      Error - 404 | Not Found
    </div>
  );
};

export default Error;
